var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('el-tooltip',{attrs:{"content":_vm.info,"placement":"right","disabled":!_vm.info}},[_c('i',{class:_vm.icon})]),_vm._v("\n  "+_vm._s(_vm.text)),_c('sup',[_vm._v(_vm._s(_vm.sup))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }